// src/Pages/Kuldevi/ViewGotra.jsx

import React from 'react';
import { useDispatch } from 'react-redux';
import { closeModal } from '../../redux/features/modalSlice';

function ViewGotra({ data }) {
  const dispatch = useDispatch();

  if (!data) {
    return (
      <div className="text-center py-4">
        <p>No data available</p>
      </div>
    );
  }

  return (
    <div>
      <div className="mb-3">
        <label className="fw-bold">ID</label>
        <p className="form-control-plaintext">{data.id || 'N/A'}</p>
      </div>

      <div className="mb-3">
        <label className="fw-bold">Kuldevi Name</label>
        <p className="form-control-plaintext">{data.kuldevi_name || data.name || 'N/A'}</p>
      </div>

      <div className="mb-3">
        <label className="fw-bold">Status</label>
        <p className="form-control-plaintext">
          <span className={`badge ${data.status === 'active' || data.status === 1 ? 'bg-success' : 'bg-danger'}`}>
            {data.status === 'active' || data.status === 1 ? 'Active' : 'Inactive'}
          </span>
        </p>
      </div>

      {data.created_at && (
        <div className="mb-3">
          <label className="fw-bold">Created At</label>
          <p className="form-control-plaintext">
            {new Date(data.created_at).toLocaleString()}
          </p>
        </div>
      )}

      {data.updated_at && (
        <div className="mb-3">
          <label className="fw-bold">Updated At</label>
          <p className="form-control-plaintext">
            {new Date(data.updated_at).toLocaleString()}
          </p>
        </div>
      )}

      <div className="d-flex justify-content-end">
        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => dispatch(closeModal())}
        >
          Close
        </button>
      </div>
    </div>
  );
}

export default ViewGotra;